module.exports = __webpack_public_path__ + "img/Doc19_Ott-Citizen-12-Nov-1941-p-22_Armistice-of-1918.a853d7fc.jpg";